import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { useSelect, useButton } from 'react-aria';
import { useSelectState } from 'react-stately';
import { useRef, useCallback, useMemo } from 'react';

var useDropdown = function (_a) {
    var _b = _a.inputProps, value = _b.value, onChange = _b.onChange, inputEvents = __rest(_b, ["value", "onChange"]), disabled = _a.disabled, readOnly = _a.readOnly, label = _a.label, children = _a.children, items = _a.items;
    var triggerRef = useRef(null);
    var handleChange = useCallback(function (key) {
        onChange(key);
    }, [onChange]);
    var stateProps = useMemo(function () { return (__assign(__assign({ children: children, items: items, label: label }, inputEvents), { onBlur: function (event) {
            var _a;
            (_a = inputEvents.onBlur) === null || _a === void 0 ? void 0 : _a.call(inputEvents, event);
        }, onFocus: function (event) {
            var _a;
            (_a = inputEvents.onFocus) === null || _a === void 0 ? void 0 : _a.call(inputEvents, event);
        }, selectedKey: value, onSelectionChange: handleChange, isDisabled: disabled || readOnly })); }, [children, items, disabled, handleChange, value, inputEvents, label, readOnly]);
    var state = useSelectState(stateProps);
    var _c = useSelect(stateProps, state, triggerRef), triggerProps = _c.triggerProps, menuProps = _c.menuProps, labelProps = _c.labelProps;
    var buttonProps = useButton(triggerProps, triggerRef).buttonProps;
    return {
        state: state,
        listboxProps: menuProps,
        labelProps: labelProps,
        triggerProps: buttonProps,
        triggerRef: triggerRef,
    };
};

export { useDropdown };
